import { render, staticRenderFns } from "./AdvertisementForm.vue?vue&type=template&id=1b5d220e&scoped=true&lang=pug"
import script from "./AdvertisementForm.vue?vue&type=script&lang=js"
export * from "./AdvertisementForm.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementForm.vue?vue&type=style&index=0&id=1b5d220e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d220e",
  null
  
)

export default component.exports